<template>
  <search-page/>
</template>

<script>
import SearchPage from '@/components/search-page/search-page'
import DefaultGuards from '@/guards/default.guards'
export default {
  name: 'SearchPageView',
  components: {
    SearchPage
  },
  beforeRouteUpdate: DefaultGuards.onQuery('events', {sort: 'createdAt desc'})
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/search-page/search-page.view.vue